(function () {
  'use strict';

  if (window.__aspIgLooxSnippetAbLoaded) return;
  window.__aspIgLooxSnippetAbLoaded = true;

  var STYLE_ID = 'asp-ig-loox-snippet-ab-style';
  var mode = 'off';

  function previewMode() {
    try {
      var q = new URLSearchParams(window.location.search).get('asp_loox_snippet');
      if (q === 'top') return 'top';
      if (q === '1' || q === 'true' || q === 'bottom') return 'bottom';
    } catch (e) {}
    return '';
  }

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.product-info__block-item:has([data-asp-loox-snippet-slot]),' +
      '.product-info__block-item:has(loox-snippets-widget),' +
      '.shopify-block:has(loox-snippets-widget),' +
      '.shopify-app-block:has(loox-snippets-widget),' +
      'loox-snippets-widget{display:none!important}' +
      'html[data-asp-loox-snippet="bottom"] .product-info__block-item:has([data-asp-loox-snippet-slot="bottom"]),' +
      'html[data-asp-loox-snippet="bottom"] [data-asp-loox-snippet-slot="bottom"],' +
      'html[data-asp-loox-snippet="bottom"] [data-asp-loox-snippet-slot="bottom"] loox-snippets-widget{display:block!important}' +
      'html[data-asp-loox-snippet="top"] .product-info__block-item:has([data-asp-loox-snippet-slot="top"]),' +
      'html[data-asp-loox-snippet="top"] [data-asp-loox-snippet-slot="top"],' +
      'html[data-asp-loox-snippet="top"] [data-asp-loox-snippet-slot="top"] loox-snippets-widget{display:block!important}';
    document.head.appendChild(style);
  }

  function slot(name) {
    return document.querySelector('[data-asp-loox-snippet-slot="' + name + '"]');
  }

  function place(next) {
    var widget = document.querySelector('loox-snippets-widget');
    var target = slot(next);
    if (!widget || !target || widget.parentElement === target) return;
    target.appendChild(widget);
  }

  function apply(next) {
    mode = next === 'top' || next === 'bottom' ? next : 'off';
    ensureStyle();
    if (mode !== 'off') place(mode);
    document.documentElement.dataset.aspLooxSnippet = mode;
    document.documentElement.classList.toggle('asp-loox-snippet-on', mode !== 'off');
  }

  function storedMode() {
    var flag = window.__ASP_LOOX_SNIPPET__;
    if (flag === 'top') return 'top';
    if (flag === 'bottom' || flag === true) return 'bottom';
    return 'off';
  }

  function sync() {
    var preview = previewMode();
    apply(preview || storedMode());
  }

  function enableLooxSnippet() {
    window.__ASP_LOOX_SNIPPET__ = 'bottom';
    sync();
  }

  function enableLooxSnippetTop() {
    window.__ASP_LOOX_SNIPPET__ = 'top';
    sync();
  }

  function disableLooxSnippet() {
    window.__ASP_LOOX_SNIPPET__ = 'off';
    sync();
  }

  window.aspEnableLooxSnippet = enableLooxSnippet;
  window.aspEnableLooxSnippetTop = enableLooxSnippetTop;
  window.aspDisableLooxSnippet = disableLooxSnippet;
  window.aspRefreshLooxSnippetAb = sync;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  setTimeout(sync, 800);
  setTimeout(sync, 2500);
})();
